export default "__VITE_ASSET__a1wdIR6Y__"